import {
  PluginOnsiteEditSchema_2024_05_05,
  PluginOnsiteEditType_2024_05_05,
} from "./2024-05-05";

export const PluginOnsiteEditSchema = PluginOnsiteEditSchema_2024_05_05;
export type PluginOnsiteEditType = PluginOnsiteEditType_2024_05_05;

export type { PluginOnsiteEditType_2024_05_05 };
